export default "__VITE_ASSET__B8tyWvn7__"